import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import { TkGetCodeList } from "../../utils/TkGetCode";
import { ApplicableOrNotApplicable } from "../../assets/data/Constants";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";

const steps = [
  "退職者の基本情報登録",
  "添付書類の登録",
  "就業状況の登録確認",
  "退職した月以前の本俸月額登録",
  "退職手当金請求の順番登録",
  "源泉徴収票の登録",
  "登録内容の確認",
  "機構へ提出",
];

const fakeTableList: ITkFakeTableLineProps[] = [
  {
    keyword: "contractorName",
    type: "contractorAndNumber",
    contractorName: "契約者（法人）名",
    showLine: false,
  },
  {
    title: "職員番号",
    keyword: "staffNo",
    type: "text",
  },
  {
    title: "退職者名",
    keyword: "retirementStaffName",
    type: "text",
  },
  {
    title:
      "現在の共済契約者と転職先の共済契約者が、施設運営上の理由により人材を融通することを事前に合意した転職である",
    keyword: "mutualTransferAgreementFlg",
    type: "radio",
    radioPropsList: TkGetCodeList(ApplicableOrNotApplicable),
    requiredIcon: true,
  },
  {
    title:
      "現在の共済契約者の退職日の翌日が、転職先の共済契約者への就職日である",
    keyword: "mutualTransferDateFlg",
    type: "radio",
    radioPropsList: TkGetCodeList(ApplicableOrNotApplicable),
    requiredIcon: true,
  },
  {
    title: "転職先の共済契約者番号",
    keyword: "aContractorNo",
    type: "label",
    onlyNumber: true,
    inputProps: { maxLength: 6 },
    requiredIcon: true,
    showLine: false,
  },
  {
    title: "転職先の共済契約者名",
    keyword: "aContractorName",
    type: "label",
    inputProps: { maxLength: 85 },
    requiredIcon: true,
    showLine: false,
  },
];

const schema1 = {
  mutualTransferAgreementFlg: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
  mutualTransferDateFlg: {
    required: TkPropertyMessageGet("TKMSG_SCR0044E"),
  },
};

const schema2 = {
  aContractorNo: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    maxLength: {
      value: 6,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "6"),
    },
    pattern: {
      value: /^[0-9]*$/,
      message: TkPropertyMessageGet("TKMSG_SCR0053E"),
    },
  },
  aContractorName: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    maxLength: {
      value: 48,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "48"),
    },
    pattern: {
      // eslint-disable-next-line no-control-regex
      value: /^[^\x00-\x08\x0B\x0C\x0E-\x1F\x7F -~｡-ﾟ]+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0061E"),
    },
  },
};

export { steps, fakeTableList, schema1, schema2 };
